import { render, staticRenderFns } from "./PolicyPrivacyView.vue?vue&type=template&id=056e399d&"
import script from "./PolicyPrivacyView.vue?vue&type=script&lang=js&"
export * from "./PolicyPrivacyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports